import { Platform } from 'react-native';

export const AUTH_SESSION_STORAGE_KEY = 'getapet:auth-session-change';

function notifySessionChange(key: string) {
  if (key !== 'apiKey') return;

  try {
    // Storage events reach other tabs without storing or broadcasting credentials.
    window.localStorage.setItem(AUTH_SESSION_STORAGE_KEY, `${Date.now()}:${Math.random()}`);
  } catch {
    // Tabs also check their cookie when they become visible or regain focus.
  }
}

function get(key: string): string | null {
  if (Platform.OS === 'web') {
    const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
    const value = match?.[2];
    if (!value) return null;

    try {
      // Match server cookie parsing, including values encoded by PHP's setcookie.
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return null;
}

function set(key: string, value: string) {
  if (Platform.OS === 'web') {
    const expires = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365).toUTCString();

    document.cookie = `${key}=${value}; Path=/; Expires=${expires}`;
    notifySessionChange(key);
  } else {
    // implement native
  }
}

async function setAndWait(key: string, value: string): Promise<void> {
  set(key, value);
}

function remove(key: string) {
  if (Platform.OS === 'web') {
    document.cookie = `${key}=; Path=/; Max-Age=0;`;
    notifySessionChange(key);
  } else {
    // implement native
  }
}

async function removeAndWait(key: string): Promise<void> {
  remove(key);
}

async function hydrate(key: string) {
  return get(key);
}

export const keychain = {
  get,
  set,
  setAndWait,
  remove,
  removeAndWait,
  hydrate,
};
